import { forwardRef, type Ref, type SVGProps } from "react";
const IconBusSideFilledSVG = (
  { children, ...rest }: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    viewBox="0 0 32 32"
    ref={ref}
    {...rest}
  >
    {children}
    <path
      fill="currentColor"
      d="M8 19a4 4 0 1 0 4 4 4 4 0 0 0-4-4m0 6a2 2 0 1 1 2-2 2 2 0 0 1-2 2m15-6a4 4 0 1 0 4 4 4 4 0 0 0-4-4m0 6a2 2 0 1 1 2-2 2 2 0 0 1-2 2"
    />
    <path
      fill="currentColor"
      d="M29 5H3a2 2 0 0 0-2 2v15a2 2 0 0 0 2 2h3.3a2.4 2.4 0 0 1-.2-.4 1 1 0 0 0 0-.1 1.8 1.8 0 0 1 0-1 2.4 2.4 0 0 1 .2-.5 2 2 0 0 1 3.4 0 2.4 2.4 0 0 1 .2.4 1 1 0 0 0 0 .1 1.8 1.8 0 0 1 0 1 2.4 2.4 0 0 1-.2.5h11.6a2.4 2.4 0 0 1-.2-.4 1 1 0 0 0 0-.1 1.8 1.8 0 0 1 0-1 2.4 2.4 0 0 1 .2-.5 2 2 0 0 1 3.4 0 2.4 2.4 0 0 1 .2.4 1 1 0 0 0 0 .1 1.8 1.8 0 0 1 0 1 2.4 2.4 0 0 1-.2.5H29a2 2 0 0 0 2-2V7a2 2 0 0 0-2-2m-10 7H3V7h16zm10 0h-8V7h8z"
    />
  </svg>
);
const ForwardRef = forwardRef(IconBusSideFilledSVG);
ForwardRef.displayName = "IconBusSideFilled";
export { ForwardRef as IconBusSideFilled };
